import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "input"]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.indexValue = this.listTarget.querySelectorAll(".proposed-location-item").length
  }

  add() {
    const index = this.indexValue
    const template = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, index)

    this.listTarget.insertAdjacentHTML("beforeend", template)
    this.indexValue++

    // Initialize autocomplete on the new input
    const newItem = this.listTarget.lastElementChild
    const input = newItem.querySelector("[data-proposed-location-target='input']")
    if (input) {
      this.initializeAutocomplete(input, newItem)
    }
  }

  remove(event) {
    const item = event.target.closest(".proposed-location-item")
    if (item) {
      item.remove()
    }
  }

  initializeAutocomplete(input, container) {
    if (typeof google === "undefined" || !google.maps) {
      setTimeout(() => this.initializeAutocomplete(input, container), 100)
      return
    }

    google.maps.importLibrary("places").then(() => {
      const autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ["name", "formatted_address", "address_components", "geometry", "place_id", "types"]
      })

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace()
        if (!place.geometry) return

        this.fillPlaceFields(container, place)
      })
    })
  }

  fillPlaceFields(container, place) {
    const isRegion = place.types?.some(type =>
      ["locality", "administrative_area_level_1", "administrative_area_level_2", "country"].includes(type)
    )

    const displayName = isRegion ? place.formatted_address : place.name

    const nameInput = container.querySelector("[data-field='name']")
    const latInput = container.querySelector("[data-field='latitude']")
    const lngInput = container.querySelector("[data-field='longitude']")
    const placeIdInput = container.querySelector("[data-field='place_id']")

    if (nameInput) nameInput.value = displayName
    if (latInput) latInput.value = place.geometry.location.lat()
    if (lngInput) lngInput.value = place.geometry.location.lng()
    if (placeIdInput) placeIdInput.value = place.place_id
  }
}
